'use client';

import Link from 'next/link';
import type { OpdsFeed, LibraryConnection } from '@/lib/opds/types';
import { encodeFeedPath } from '@/lib/utils/url';

export function PaginationControls({
  feed,
  library,
}: {
  feed: OpdsFeed;
  library: LibraryConnection;
}) {
  const { nextUrl, prevUrl } = feed.pagination;

  if (!nextUrl && !prevUrl) return null;

  return (
    <div className="flex items-center justify-between border-t border-neutral-200 pt-4">
      {prevUrl ? (
        <Link
          href={`/library/${library.id}/feed/${encodeFeedPath(prevUrl)}`}
          className="flex items-center gap-1 rounded-lg px-4 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-100"
        >
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          Previous
        </Link>
      ) : (
        <div />
      )}

      {feed.totalResults != null && (
        <span className="text-xs text-neutral-400">
          {feed.totalResults} results
        </span>
      )}

      {nextUrl ? (
        <Link
          href={`/library/${library.id}/feed/${encodeFeedPath(nextUrl)}`}
          className="flex items-center gap-1 rounded-lg px-4 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-100"
        >
          Next
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      ) : (
        <div />
      )}
    </div>
  );
}
